import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import {Menu, MenuItem} from '../../atoms/Menu';
import TranslatedText from '../../atoms/TranslatedText';
import i18n from '../../locales/i18n';

import './SeeForYourself.css';

const MENU = {
    baseball: {
        title: 'prizm.see_for_yourself.menu.baseball',
        img: require('./baseball.jpg'),
    },
    golf: {
        title: 'prizm.see_for_yourself.menu.golf',
        img: require('./golf.jpg'),
    },
    road: {
        title: 'prizm.see_for_yourself.menu.road',
        img: require('./road.jpg'),
    },
    trail: {
        title: 'prizm.see_for_yourself.menu.trail',
        img: require('./trail.jpg'),
    },
    mx: {
        title: 'prizm.see_for_yourself.menu.mx',
        img: require('./mx.jpg'),
    },
    snow: {
        title: 'prizm.see_for_yourself.menu.snow',
        img: require('./snow.jpg'),
    },
};

export default class SeeForYourself extends PureComponent {
    state = {type: this.props.match.params.type};

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.type !== state.type) {
            return {type: props.match.params.type};
        }

        return null;
    }

    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/Priz/SeeForYourself/${
                this.props.match.params.type
            }`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/Priz/SeeForYourself/${
                this.props.match.params.type
            }`
        );
    }

    render() {
        const type = this.props.match.params.type;
        const currentType = MENU[type];
        const history = this.props.history;
        const style = {backgroundImage: `url(${currentType.img})`};
        return (
            <article className="SeeForYourself" style={style}>
                <div className="SeeForYourself-bottom">
                    <div className="SeeForYourself-label">
                        <TranslatedText
                            tag={`prizm.see_for_yourself.labels.${type}`}
                        />
                    </div>
                </div>

                <Menu className="SeeForYourself-menu">
                    <MenuItem
                        tag="prizm.see_for_yourself.menu.baseball"
                        onClick={() =>
                            history.push('/prizm/see-for-yourself/baseball')
                        }
                        active={this.state.type === 'baseball'}
                    />
                    <MenuItem
                        tag="prizm.see_for_yourself.menu.golf"
                        onClick={() =>
                            history.push('/prizm/see-for-yourself/golf')
                        }
                        active={this.state.type === 'golf'}
                    />
                    <MenuItem
                        tag="prizm.see_for_yourself.menu.road"
                        onClick={() =>
                            history.push('/prizm/see-for-yourself/road')
                        }
                        active={this.state.type === 'road'}
                    />
                    <MenuItem
                        tag="prizm.see_for_yourself.menu.trail"
                        onClick={() =>
                            history.push('/prizm/see-for-yourself/trail')
                        }
                        active={this.state.type === 'trail'}
                    />
                    <MenuItem
                        tag="prizm.see_for_yourself.menu.mx"
                        onClick={() =>
                            history.push('/prizm/see-for-yourself/mx')
                        }
                        active={this.state.type === 'mx'}
                    />
                    <MenuItem
                        tag="prizm.see_for_yourself.menu.snow"
                        onClick={() =>
                            history.push('/prizm/see-for-yourself/snow')
                        }
                        active={this.state.type === 'snow'}
                    />
                </Menu>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/prizm/SeeForYourself.js